import BasicDetails from './basicDetails';
export default BasicDetails;